/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Calendar_Scope_AgendaInputs */



/**
* | output |
* | --- |
* | "your personal agenda" |
*
* @param {Tournaments_Calendar_Scope_AgendaInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_calendar_scope_agenda = /** @type {((inputs?: Tournaments_Calendar_Scope_AgendaInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Calendar_Scope_AgendaInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("votre agenda personnel")
	if (locale === "es") return /** @type {LocalizedString} */ ("su agenda personal")
	if (locale === "pt") return /** @type {LocalizedString} */ ("sua agenda pessoal")
	if (locale === "it") return /** @type {LocalizedString} */ ("la tua agenda personale")
	return /** @type {LocalizedString} */ ("your personal agenda")
});